<script>
import { mapGetters } from 'vuex'

export default {
  name: 'graph-theme-mixin',

  computed: {
    ...mapGetters('gui', [
      'darkMode',
    ]),

    themeBackground() {
      if(this.darkMode) {
        return '#23242d';
      } else {
        return '#ffffff';
      }
    },

    themeDataLabelsForeColors() {
      if(this.darkMode) {
        return ['#e1e1e1'];
      } else {
        return ['#3c4b64'];
      }
    },

  },
}
</script>
